import api from './api';

// MIGRATION: Removed independent agent routing logic
// All agents now use unified /itineraries endpoints
// Backend handles role-based filtering automatically

export const itinerariesService = {
  // Get all itineraries
  getAll: async (params = {}) => {
    const response = await api.get('/itineraries', { params });
    return response.data;
  },

  // Get completed/archived itineraries
  getCompleted: async (params = {}) => {
    const response = await api.get('/itineraries/completed', { params });
    return response.data;
  },

  // Get single itinerary
  getById: async (id) => {
    const response = await api.get(`/itineraries/${id}`);
    return response.data;
  },

  // Update itinerary
  update: async (id, itineraryData) => {
    const response = await api.put(`/itineraries/${id}`, itineraryData);
    return response.data;
  },

  // Add payment to itinerary
  addPayment: async (itineraryId, paymentData) => {
    const response = await api.post(`/itineraries/${itineraryId}/payments`, paymentData);
    return response.data;
  },

  // Get itinerary payments
  getPayments: async (itineraryId) => {
    const response = await api.get(`/itineraries/${itineraryId}/payments`);
    return response.data;
  },

  // Send update to client
  sendUpdate: async (itineraryId, updateData) => {
    const response = await api.post(`/itineraries/${itineraryId}/send-update`, updateData);
    return response.data;
  },

  // Find itinerary by quote ID
  findByQuoteId: async (quoteId) => {
    const response = await api.get(`/itineraries/from-quote/${quoteId}`);
    return response.data;
  },

  // Delete itinerary
  delete: async (id) => {
    const response = await api.delete(`/itineraries/${id}`);
    return response.data;
  },

  // Archive itinerary (move to Completed Travel tab)
  archive: async (id) => {
    const response = await api.patch(`/itineraries/${id}/archive`);
    return response.data;
  },

  // Unarchive itinerary (move back to Active Bookings)
  unarchive: async (id) => {
    const response = await api.patch(`/itineraries/${id}/unarchive`);
    return response.data;
  }
};
